import { Tabs } from 'antd';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import ReactPlayer from 'react-player';
import Slider from 'react-slick';
import { Sticky, StickyContainer } from 'react-sticky';
import useWindowDimensions from '../../../../hooks/Front/windowDimentions/useDimentions';
import './secciones.css';

const { TabPane } = Tabs;

const ExperienciaClientes = ({ experiencias }) => {

    const { width } = useWindowDimensions();


    let margen = width <= 767 ? "130px" : width <= 991 ? "260px" : "198px"

    const renderTabBar = (props, DefaultTabBar) => (
        <Sticky topOffset={-90}>
            {({ style, isSticky }) => (
                <DefaultTabBar {...props} style={{ ...style, zIndex: 100, height: "80px", top: isSticky ? margen : '0px' }} />
            )}
        </Sticky>
    );


    if (!experiencias) return null;
    return (
        <StickyContainer >
            <Tabs defaultActiveKey="fotos" className="tab-vehiculo" centered id="tab-especificacion" renderTabBar={renderTabBar}>
                {experiencias.Fotos && experiencias.Fotos.length > 0 &&
                    <TabPane tab={<h5 className="parrafo-hyundai f-18 color-mobile px-5 px-tabs-especificacion my-3">Fotos</h5>} key="fotos">
                        <SeccionImagenes imagenes={experiencias.Fotos} />
                    </TabPane>
                }

                {experiencias.Videos && experiencias.Videos.length > 0 &&
                    <TabPane tab={<h5 className="parrafo-hyundai f-18 color-mobile px-5 px-tabs-especificacion my-3">Videos</h5>} key="videos">
                        <SeccionVideos videos={experiencias.Videos} />
                    </TabPane>
                }
            </Tabs>
        </StickyContainer>
    )
};


const SeccionVideos = ({ videos }) => {

    if (!videos || videos.length < 1) return null;

    let cantidadCard = videos.length >= 3 ? 3 : videos.length < 2 ? 1 : 2
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: cantidadCard,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1360,
                settings: {
                    slidesToShow: cantidadCard === 3 ? 2 : cantidadCard < 2 ? 1 : 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            }
        ]
    };
    return (
        <Row>
            <Col xs={11} md={cantidadCard === 3 ? 8 : cantidadCard * 3} className="mx-auto mb-5">
                <Slider {...settings} className="slider-multiple">
                    {videos && videos.length > 0 &&
                        videos.map((video, i) =>
                            <Col className="px-0" key={i}>
                                <div className="player-wrapper my-5" key={i} >
                                    <ReactPlayer width="100%" height="100%" className="hyundai-video-player px-3" url={video.Multimedia} />
                                </div>
                            </Col>
                        )
                    }
                </Slider>
            </Col>
        </Row>
    );
}


const SeccionImagenes = ({ imagenes }) => {

    let cantidadCard = imagenes.length >= 3 ? 3 : imagenes.length < 2 ? 1 : 2
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: cantidadCard,
        slidesToScroll: 1,

        responsive: [
            {
                breakpoint: 1360,
                settings: {
                    slidesToShow: cantidadCard === 3 ? 2 : cantidadCard < 2 ? 1 : 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            }
        ]
    };
    return (
        <Row>
            <Col xs={10} md={cantidadCard === 3 ? 8 : cantidadCard * 3} className="mx-auto mb-5">
                <Slider {...settings} className="slider-multiple">
                    {imagenes && imagenes.length > 0 &&
                        imagenes.map((imagen, i) => 
                            <Col className="px-0" key={i}>
                                <img src={imagen.Multimedia} alt={imagen.Seccion}  className="my-5 px-md-3 mb-ec" key={i} />
                            </Col>
                        )
                    }
                </Slider>
            </Col>
        </Row>
    )
}

export default ExperienciaClientes;